export default "__VITE_ASSET__ba8db8d7__"